import {
  Stack,
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  stepConnectorClasses,
  styled,
} from '@mui/material';
import { Check } from '@mui/icons-material';
import * as React from 'react';
import './Stepper.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  steps: string[];
  className?: string;
  currentStep: number;
}

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#784af4',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

const QontoStepIcon: React.FC<StepIconProps> = (props) => {
  const { active, completed, className } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
    </QontoStepIconRoot>
  );
};

export const CustomizedSteppers: React.FC<Props> = ({ steps, className = '', currentStep }) => {
  const { t } = useTranslation();
  return (
    <Stack sx={{ width: '100%' }} spacing={3}>
      <Stepper className={`test ${className}`} alternativeLabel activeStep={currentStep} connector={<QontoConnector />}>
        {steps.map((label,index) => (
          <Step key={label}>
            <StepLabel className="label-size " StepIconComponent={QontoStepIcon}>
              {t(label)}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

export const MobileStepper:React.FC<Props> = ({ steps, className = '', currentStep }) => {
  const { t } = useTranslation();
  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper className={`test ${className}`} alternativeLabel activeStep={currentStep} connector={<QontoConnector />}>
        {steps.map((label,index) => (
          <Step key={label}>
            <StepLabel className="label-size phn" StepIconComponent={QontoStepIcon}>
              { currentStep===index? t(label) :''}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

